export default __webpack_public_path__ + "6055e2ec58257f9412ae043de5332489.jpg";